// extracted by mini-css-extract-plugin
module.exports = {"benefitName":"_7dbnRYTbHnXXBZSSjgmB-A==","benefitNameMobile":"_43zAsJiYvEjnV56q-a2vdg==","valueBadge":"txqhsthr8VgEzzMIiDuuiw==","description":"fGNRmt4emp+wYPY-8HyEFQ=="};